import { motion } from "framer-motion";
import { MaskLines } from "./Reveal";

export default function PageHeader({ overline, title, lines, sub, image }) {
  return (
    <section className="relative pt-40 md:pt-52 pb-16 md:pb-24 overflow-hidden" data-testid="page-header">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-background/85" />
          <div className="absolute inset-0 bg-gradient-to-t from-background to-transparent" />
        </div>
      )}
      <div className="relative max-w-[1600px] mx-auto px-6 md:px-10">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="overline text-primary mb-6"
        >
          {overline}
        </motion.p>
        <h1 className="font-display uppercase text-foreground text-5xl sm:text-7xl lg:text-[8vw] leading-[0.85]">
          {lines ? <MaskLines lines={lines} /> : title}
        </h1>
        {sub && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="font-editorial italic text-2xl md:text-3xl text-muted-foreground max-w-2xl mt-8"
          >
            {sub}
          </motion.p>
        )}
      </div>
    </section>
  );
}
